import emailjs from '@emailjs/browser'

const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID
const DEMO_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_DEMO_TEMPLATE_ID
const SIGNUP_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_SIGNUP_TEMPLATE_ID

if (PUBLIC_KEY) {
  emailjs.init({ publicKey: PUBLIC_KEY })
}

function assertReady(templateId: string | undefined, label: string) {
  if (!PUBLIC_KEY || !SERVICE_ID || !templateId) {
    throw new Error(
      `EmailJS ${label} not configured — check REACT_APP_EMAILJS_* in .env.local`
    )
  }
}

export async function sendDemoRequest(params: Record<string, string>) {
  assertReady(DEMO_TEMPLATE_ID, 'demo template')
  return emailjs.send(SERVICE_ID!, DEMO_TEMPLATE_ID!, params)
}

export async function sendSignup(params: Record<string, string>) {
  assertReady(SIGNUP_TEMPLATE_ID, 'signup template')
  return emailjs.send(SERVICE_ID!, SIGNUP_TEMPLATE_ID!, params)
}
